import { render, staticRenderFns } from "./accountInfo.vue?vue&type=template&id=851d3b18"
import script from "./accountInfo.vue?vue&type=script&lang=js"
export * from "./accountInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports